import { gql } from "@apollo/client";

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    getAllUsers {
      users {
        email
        id
        fullName
        role
        status
        verifiedPhoneNumber
        phone
      }
    }
  }
`;

export const GET_USER_BY_ID = gql`
  # query GetUserById($getUserById: ID!) {
  #   getUserById(id: $getUserById) {
  #     id
  #     fullName
  #     status
  #     phone
  #     email
  #     accountType
  #   }
  # }
  query GetUserById {
    getUserById {
      id
      fullName
      status
      phone
      email
      accountType
      organizationName
    }
  }
`;

export const getAllUsersByOrganizationId = gql`
  # query GetAllUsersByOrganizationId($organizationId: ID!) {
  #   getAllUsersByOrganizationId(organizationId: $organizationId) {
  #     email
  #     id
  #     fullName
  #     firstName
  #     lastName
  #     role
  #     status
  #     verifiedPhoneNumber
  #     phone
  #     organization_role_id
  #   }
  # }
  query GetAllUsersByOrganizationId {
    getAllUsersByOrganizationId {
      email
      id
      fullName
      firstName
      lastName
      role
      status
      verifiedPhoneNumber
      phone
      organization_role_id
    }
  }
`;

export const getAllRoles = gql`
  query GetAllRoles($filters: RoleFilters) {
    getAllRoles(filters: $filters) {
      data {
        id
        name
        description
        type
        meta
      }
    }
  }
`;

export const getAllPermissions = gql`
  query GetAllPermissions($filters: PermissionFilters) {
    getAllPermissions(filters: $filters) {
      data {
        id
        name
        description
        type
        meta
      }
    }
  }
`;

export const getRolePermissions = gql`
  query Query($roleId: ID!) {
    rolePermissions(roleId: $roleId) {
      id
      roleId
      permissionId
      meta
    }
  }
`;

export const get2FAStatusById = gql`
  query Get2FAStatusById {
    get2FAStatusById {
      success
      message
    }
  }
`;
